import {GetStaticPropsResult} from "next"
import {DrupalNode, DrupalTaxonomyTerm} from "next-drupal"

import {drupal} from "lib/drupal"
import {Layout} from "components/layout"
import FiltersFormRecherche from "@/components/filtersForm/FiltersFormRecherche";
import {Separator} from "@radix-ui/react-menu";
import Container from "@/components/ui/container";
import PaginationList from "@/components/pagination/PaginationList";
import {NodePodcastEmission, NodePodcastPromoted, NodePodcastSearch} from "@/components/nodeTypes";
import {
  getEmissions, getLatestPodcast, getPodcast,
  getPromotedPodcasts,
  getSearchedPodcasts,
  getTermThematique
} from "@/lib/drupalFetcher";
import Breadcrumbs from "@/components/breadcrumb";
import {HeadMetadata} from "@/components/headMetadata";
import * as React from "react";

interface PodcastsPageProps {
  nodesEmissions: DrupalNode[],
  nodesPromoted: DrupalNode[],
  nodesPodcast: DrupalNode[],
  thematiques: DrupalTaxonomyTerm[]
  limit: number,
  count: number,
  contextQuery: Object,
  emptyResearch: boolean
}

export default function PodcastsPage({nodesEmissions, nodesPromoted, nodesPodcast, thematiques, limit, count, contextQuery, emptyResearch}: PodcastsPageProps) {

  const resourcesEmissions = drupal.deserialize(nodesEmissions) as DrupalNode[];
  const resourcesPromoted = drupal.deserialize(nodesPromoted) as DrupalNode[];
  let resourcesPodcast = !emptyResearch ? drupal.deserialize(nodesPodcast) as DrupalNode[] : [];
  const breadcrumb = [
    {label: 'Podcast' }
  ];

  return (
    <Layout>
      <HeadMetadata
        title="Podcasts"
        description="Retrouvez tous les podcasts de vos émissions favorites."
      />

      <Container className="py-10">
        <Breadcrumbs entries={breadcrumb} />

        <div>
          <h1 className="mb-2 text-[40px] text-foreground-dark">Podcasts</h1>

          <p className='text-foreground-light mb-3'>Retrouvez tous les podcasts de vos émissions favorites.</p>

          <FiltersFormRecherche thematiques={thematiques} contextQuery={contextQuery} />

          <Separator className='mb-4'/>

          { !emptyResearch ? (
            <>
              <h1 className="mb-2 text-[40px] text-foreground-dark">Toutes nos émissions en réécoute</h1>

              {resourcesPodcast && resourcesPodcast.length > 0 ? (
                <NodePodcastSearch podcasts={resourcesPodcast}/>
              ) : (
                <p className="py-4">Aucun podcast trouvé</p>
              )}

              <PaginationList count={count} limit={limit} contextQuery={contextQuery}/>
            </>
          ) : (
            <>
              {resourcesPromoted && resourcesPromoted.length > 0 && (
                <>
                <div className="mb-8">
                  <p className='text-[32px] text-foreground-dark mb-3'>Nouveaux épisodes</p>

                      <NodePodcastPromoted podcasts={resourcesPromoted}/>
                </div>
                </>
              )}
              <Separator className='mb-4'/>

              <h1 className="mb-2 text-[40px] text-foreground-dark">Toutes nos émissions en réécoute</h1>

              <div className="mb-8">
                {resourcesEmissions && resourcesEmissions.length > 0 &&
                    <NodePodcastEmission node={resourcesEmissions}/>}
              </div>

              <PaginationList count={count} limit={limit} contextQuery={contextQuery}/>
            </>
            )}

        </div>
      </Container>
    </Layout>
  )
}

export async function getServerSideProps(context): Promise<GetStaticPropsResult<PodcastsPageProps>> {

  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=60, stale-while-revalidate=0, max-age=60'
  )

  // Récupération des query params
  const contextQuery = context.query || {};
  const page = contextQuery.page || 1;
  const search = contextQuery.search || '';
  const thematique = contextQuery.thematique || '';

  const limit = 12; // A modifier : limit sur la liste des emissions et sur la liste des podcasts (recherche)
  const offset = (page - 1) * limit;

  const emptyResearch = (search == '' && thematique == '');

  let count = 0;
  let nodesPromoted: DrupalNode[] = [];
  let nodesEmissions: DrupalNode[] = [];
  let nodesPodcast: DrupalNode[] = [];

  // Si la recherche n'est pas activé
  if (emptyResearch) {

    // Récupération de la liste des podcasts mise en avant
    nodesPromoted = await getPodcast(context);

    // Récupération de la liste des émissions
    nodesEmissions = await getEmissions(context, limit, offset);

    // @ts-ignore
    count = nodesEmissions.meta.count || 0;

  } else {
    // Recherche activé

    // Récupération de la liste des podcasts
    nodesPodcast = await getSearchedPodcasts(search, thematique, page)

    // @ts-ignore
    count = nodesPodcast.meta.count || 0;

  }

  // Récupération des thématiques
  const thematiques: DrupalTaxonomyTerm[] = await getTermThematique(context)

  return {
    props: {
      nodesEmissions,
      nodesPromoted,
      nodesPodcast,
      thematiques,
      limit,
      count,
      contextQuery,
      emptyResearch
    },
  }
}
